import axios from 'axios';
import { settings } from '../config';

export async function getDailyRewards() {
  const config = {
    headers: {
      Authorization: 'Bearer 4478c2b6-525f-4b48-99a2-1e9e7da835b7',
    },
  };
  try {
    const url = `${settings.url}/task/?type=internal_checkin`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function checkSubscription(id: number) {
  const config = {
    headers: {
      Authorization: 'Bearer 4478c2b6-525f-4b48-99a2-1e9e7da835b7',
    },
  };
  try {
    const url = `${settings.url}/task/${id}/claim`;
    const response = await axios.post(url, {}, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
